export const StatisticsMessage = () => {
  return (
    <div>
      <p>Have you done the reconciliation beforehand?</p>
      <p>Yes &gt; Reconciliation made, open statistics</p>
      <p>No &gt; Start Reconciliation</p>
      <p>Back &gt; Cancel the process</p>
    </div>
  );
};
